// extracted by mini-css-extract-plugin
export default {"wrapper":"BackButton_wrapper__LSJwe","white":"BackButton_white__dEXB4","text":"BackButton_text__Yi8RA"};